module.exports = __webpack_public_path__ + "img/corte_suprema_justicia.6cc9cc4e.png";